import Label, { LabelColor } from '@/components/core/label';
import { ChoicesStatusMilestone } from '@/types';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

export interface MilestoneStatusLabelProps {
  status: ChoicesStatusMilestone;
}

export const MilestoneStatusLabel: FC<MilestoneStatusLabelProps> = ({ status }) => {
  const { t } = useTranslation();
  const statusColors: Record<ChoicesStatusMilestone, LabelColor> = {
    [ChoicesStatusMilestone.SCHEDULED]: 'default',
    [ChoicesStatusMilestone.OPEN_TO_BILL]: 'warning',
    [ChoicesStatusMilestone.PAST_DUE]: 'error',
    [ChoicesStatusMilestone.IN_PROGRESS]: 'secondary',
    [ChoicesStatusMilestone.BILLED]: 'success',
    [ChoicesStatusMilestone.CANCELLED]: 'error',
    [ChoicesStatusMilestone.REVERSED]: 'orange',
  };

  const statusLabels: Record<ChoicesStatusMilestone, string> = {
    [ChoicesStatusMilestone.SCHEDULED]: t('Scheduled'),
    [ChoicesStatusMilestone.OPEN_TO_BILL]: t('Open to Bill'),
    [ChoicesStatusMilestone.PAST_DUE]: t('Past Due'),
    [ChoicesStatusMilestone.IN_PROGRESS]: t('In Progress'),
    [ChoicesStatusMilestone.BILLED]: t('Billed'),
    [ChoicesStatusMilestone.CANCELLED]: t('Cancelled'),
    [ChoicesStatusMilestone.REVERSED]: t('Reversed'),
  };

  return (
    <Label variant="soft" color={statusColors[status] || 'default'}>
      {statusLabels[status] || t('Unknown')}
    </Label>
  );
};
